import React, { Component } from "react";
import { Icon, Layout } from "antd";
import styled from 'styled-components'
import '../style.less'
const { Footer } = Layout;

//dadam : ici il y avait position : absolute
const Footerstyled = styled(Footer) `
font-size: 14px;
background-color: #0000FE!important;
//text-align: center;
align-items: center;
bottom : 0;
left: 0;
right: 0;
top: 0;
height: 10px;
width: 100%;
display: flex;
justify-content: center;
`

export default class MyFooter extends Component {

		render() {
				return (
					<Footerstyled style={{padding:'1em' }}>
						<div style={{fontSize: '12px', color: 'white'}}>
							URBAN FITNESS FRANCE © 2018
						</div>
						<div style={{textAlign: 'center', marginLeft: 'auto'}}>
							<a href="https://www.facebook.com/urbanfitnessfrance/"> <Icon style={{ color: '#FFF', fontSize: '20px' }} type="facebook"/> </a>
							<a href="https://twitter.com/urbanfitness_fr?lang=fr"> <Icon style={{  color: '#FFF', fontSize: '20px' }} type="twitter"/>  </a>
							<a href="https://www.instagram.com/urbanfitness_fr/"> <Icon style={{ color: '#FFF', fontSize: '20px' }} type="instagram"/>  </a>
							<a href="mailto:help@urbanfitnessfrance.com/"> <Icon style={{  color: '#FFF', fontSize: '20px' }} type="mail"/>  </a>
						</div>
						</Footerstyled>
				);
			}
}
